import React, { useState } from "react";

// /debug/room-frames: the Game Rooms screens at several real screen sizes at once,
// each in its own frame (a real viewport, so its media queries are its own). The
// phones are touch screens in their frames (the "ar-phone" frame name, see
// index.tsx), so they get the sideways-phone layout. Big screens are drawn scaled.
const SIZES = [
  { name: "Phone sideways", w: 844, h: 390, phone: true },
  { name: "Small phone sideways", w: 667, h: 375, phone: true },
  { name: "Laptop", w: 1280, h: 720 },
  { name: "Tablet-wide window", w: 1024, h: 700 },
  { name: "Small window", w: 900, h: 640 },
  { name: "Narrow window", w: 600, h: 900 },
  { name: "Full HD", w: 1920, h: 1080 },
];
const PAGES = [
  { name: "Local game", path: "/local" },
  { name: "A new private room", path: "/join?create=private" },
];
export default function RoomFramesSheet() {
  // (kept in the address, so a reload of this page shows the same one)
  const [page, setPageState] = useState(() => (new URLSearchParams(window.location.search).get("p") === "room" ? PAGES[1].path : PAGES[0].path));
  const setPage = (p: string) => { setPageState(p); window.history.replaceState(null, "", p === PAGES[1].path ? "?p=room" : "?p=local"); };
  const [k, setK] = useState(0);
  return (
    <div style={{ minHeight: "100vh", background: "#04070e", color: "#e9f3ff", font: "500 14px Outfit, system-ui, sans-serif", padding: "20px 24px 60px" }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 18 }}>
        <b style={{ font: "700 18px 'Chakra Petch', sans-serif", marginRight: 12 }}>Game Rooms at every size</b>
        {PAGES.map((p) => <button key={p.path} type="button" onClick={() => { setPage(p.path); setK((v) => v + 1); }} style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid " + (page === p.path ? "#19f0b0" : "rgba(255,255,255,.15)"), background: "none", color: page === p.path ? "#19f0b0" : "#e9f3ff", cursor: "pointer" }}>{p.name}</button>)}
        <button type="button" onClick={() => setK((v) => v + 1)} style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid rgba(255,255,255,.15)", background: "none", color: "#e9f3ff", cursor: "pointer" }}>Reload all</button>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 24, alignItems: "flex-start" }}>
        {SIZES.map((z) => {
          const scale = Math.min(1, 860 / z.w);
          return (
            <div key={z.name}>
              <div style={{ font: "700 11px 'Chakra Petch', sans-serif", letterSpacing: 1.4, textTransform: "uppercase", color: "#8ea3bd", marginBottom: 6 }}>{z.name} · {z.w} x {z.h}{scale < 1 ? ` (drawn at ${Math.round(scale * 100)}%)` : ""}</div>
              <div style={{ width: z.w * scale, height: z.h * scale, overflow: "hidden", borderRadius: 10, border: "1px solid rgba(255,255,255,.2)" }}>
                <iframe key={k + page} name={z.phone ? "ar-phone" : undefined} title={z.name} src={page} style={{ width: z.w, height: z.h, border: 0, transform: `scale(${scale})`, transformOrigin: "0 0" }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
